/* eslint-disable react/prop-types */
import { createContext, useContext, useReducer } from 'react';
import { budgetLineReducer, initialState } from './reducer';

const BudgetLineContext = createContext();

export const BudgetLineProvider = ({ children }) => {
    const [state, dispatch] = useReducer(budgetLineReducer, initialState);

    return <BudgetLineContext.Provider value={[state, dispatch]}>{children}</BudgetLineContext.Provider>;
};

export const useBudgetLineContext = () => {
    const context = useContext(BudgetLineContext);
    if (!context) {
        throw new Error('useBudgetLineContext must be used within a BudgetLineProvider');
    }
    return context;
};
